import { render } from "./considering-coverage-new.vue?vue&type=template&id=f58e3a70"
import script from "./considering-coverage-new.vue?vue&type=script&lang=js"
export * from "./considering-coverage-new.vue?vue&type=script&lang=js"

import "./considering-coverage-new.vue?vue&type=style&index=0&id=f58e3a70&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__